var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "step",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c("p", { staticClass: "step__title text_x_large" }, [
        _vm._v(_vm._s(_vm.i18n.kyc_submit_document()))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "step__row" },
        [
          _c("file-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "kyc-form__file-field",
            attrs: {
              id: "kyc-business-model",
              label: _vm.i18n.kyc_upload_business_model(),
              type: _vm.documentTypes.kycBusinessModel,
              "data-vv-as": _vm.i18n.kyc_upload_business_model(),
              disabled: _vm.accountState === _vm.ACCOUNT_STATES.pending
            },
            on: {
              input: function($event) {
                return _vm.onFileInput($event)
              }
            },
            model: {
              value: _vm.documents[_vm.documentTypes.kycBusinessModel],
              callback: function($$v) {
                _vm.$set(_vm.documents, _vm.documentTypes.kycBusinessModel, $$v)
              },
              expression: "documents[documentTypes.kycBusinessModel]"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "step__description" },
        [
          _c("md-checkbox", {
            staticClass: "md-primary privacy-policy__cb",
            attrs: {
              name: "privacy-policy",
              id: "privacy-policy",
              errorMessage: _vm.errorMessage("privacy-policy")
            },
            model: {
              value: _vm.form.privacyPolicy,
              callback: function($$v) {
                _vm.$set(_vm.form, "privacyPolicy", $$v)
              },
              expression: "form.privacyPolicy"
            }
          }),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.i18n.kyc_i_agree()) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: {
                type: "submit",
                disabled:
                  _vm.isPending ||
                  _vm.accountState === _vm.ACCOUNT_STATES.pending ||
                  !_vm.form.privacyPolicy
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_submit()) + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe7eb4d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe7eb4d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/steps/syndicate/Step.BusinessModel.vue
// module id = /oNx
// module chunks = 1